import { HttpClient } from 'api/HttpClient';
import { PrequalificationVersion } from 'enums/ApplicationsVariables';
import { ConceptualHqEvent } from 'enums/ConceptualHqEvent';

export interface UpdateDeviceDto {
  deviceId?: string;
}

export interface ConceptualHqEventDto {
  event: ConceptualHqEvent;
  prequalificationVersion: PrequalificationVersion;
  borrowerId?: string | null;
  deviceId?: string;
}

export default class MarketingApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/marketing');
  }

  public async updateDevice(updateDeviceDto: UpdateDeviceDto) {
    return this.instance.put('/device', updateDeviceDto).then((response) => response.data);
  }

  public async trackConceptualHqEvent(event: ConceptualHqEventDto) {
    return this.instance.post('/track-event', event).then((response) => response.data);
  }
}

export const marketingApi = new MarketingApi();
